import { render, staticRenderFns } from "./countdown-modern.vue?vue&type=template&id=322b8db4&scoped=true"
import script from "./countdown-modern.vue?vue&type=script&lang=js"
export * from "./countdown-modern.vue?vue&type=script&lang=js"
import style0 from "./countdown-modern.vue?vue&type=style&index=0&id=322b8db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b8db4",
  null
  
)

export default component.exports